import { environment } from "@environments/environment";

const PROD_PATHS = {
  "": "rappi.com",
  MX: "rappi.com.mx",
  BR: "rappi.com.br",
  AR: "rappi.com.ar",
  CO: "rappi.com.co",
  CL: "rappi.cl",
  EC: "rappi.com.ec",
  PE: "rappi.com.pe",
  UY: "rappi.com.uy",
  CR: "rappi.co.cr",
};

const code = environment.code;

const getStylesPath = (mf, code = "") => {
  const domain = PROD_PATHS[code];
  return `https://${mf}.${domain}/static/css/bundle.min.css`;
};

export const STYLES = {
  dev: {
    fake_orders_styles: {
      name: "fake_orders_styles",
      src: "https://tmf-fake-orders.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    users_styles: {
      name: "users_styles",
      src: "https://tmf-users.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    order_tracking_styles: {
      name: "order_tracking_styles",
      src: "https://tmf-order-tracking.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    realtime_fo_styles: {
      name: "realtime_fo_styles",
      src: "https://tmf-realtime-fo.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    accuracy_tracker_styles: {
      name: "accuracy_tracker_styles",
      src: "https://tmf-accuracy-tracker.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    cargo_invoice_styles: {
      name: "cargo_invoice_styles",
      src: "https://turbo-utils-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_bulk_upload_styles: {
      name: "bulk_upload_styles",
      src: "https://turbo-bulk-upload-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_charm_price_styles: {
      name: "charm_price_styles",
      src: "https://turbo-charm-price-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_sell_pricing_styles: {
      name: "sell_pricing_styles",
      src: "https://turbo-sell-pricing-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_promotion_styles: {
      name: "turbo_promotion_styles",
      src: "https://turbo-promotions-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_competitive_styles: {
      name: "competitive_styles",
      src: "https://turbo-competitive-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_wishlist_styles: {
      name: "wishlist_styles",
      src: "https://turbo-wishlist-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    purchase_orders: {
      name: "purchase_orders_styles",
      src: "https://turbo-purchase-orders-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    consignment_orders: {
      name: "consignment_orders_styles",
      src: "https://turbo-consignment-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    po_calendar_styles: {
      name: "po_calendar_styles",
      src: "https://turbo-po-calendar-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    pos_styles: {
      name: "pos_styles",
      src: "https://turbo-pos-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    financial_managment: {
      name: "financial_managment_styles",
      src: "https://turbo-purchase-orders-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    replenishment_styles: {
      name: "replenishment_styles",
      src: "https://turbo-replenishment-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    permissions_styles: {
      name: "permissions_styles",
      src: "https://turbo-permissions-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    audit_report_styles: {
      name: "audit_report_styles",
      src: "https://turbo-audit-report-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    roles_styles: {
      name: "roles_styles",
      src: "https://turbo-roles-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    sc_approval_styles: {
      name: "sc_approval_styles",
      src: "https://turbo-sc-approval-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    transformations_styles: {
      name: "transformations_styles",
      src: "https://turbo-transformations-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    inventory_savvy_styles: {
      name: "inventory_savvy_styles",
      src: "https://turbo-inventory-savvy-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_purchase_orders_styles: {
      name: "supply_purchase_orders_styles",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_transfer_orders_styles: {
      name: "supply_transfer_orders_styles",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_consignment_orders_styles: {
      name: "supply_consignment_orders_styles",
      src: "https://turbo-pt-order-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    audit_inventory_styles: {
      name: "audit_inventory_styles",
      src: "https://turbo-audit-inventory-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    campaign_styles: {
      name: "campaign_styles",
      src: "https://turbo-campaign-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    multibrand_styles: {
      name: "multibrand_styles",
      src: "https://turbo-multibrand-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    assignments_styles: {
      name: "assignments_styles",
      src: "https://turbo-assignments-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    cold_products_styles: {
      name: "cold_products_styles",
      src: "https://turbo-cold-products.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    cyclics: {
      name: "cyclics_styles",
      src: "https://turbo-cyclics-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    catalog_styles: {
      name: "catalog_styles",
      src: "https://turbo-catalog-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    kpis_styles: {
      name: "kpis_style",
      src: "https://turbo-kpis-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    price_list_styles: {
      name: "price_list_styles",
      src: "https://turbo-price-list-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    catman_price_list_styles: {
      name: "catman_price_list_styles",
      src: "https://turbo-catman-price-list-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    order_monitoring_styles: {
      name: "order_monitoring_styles",
      src: "https://turbo-order-monitoring.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    approval_request_styles: {
      name: "approval_request_styles",
      src: "https://turbo-approval-request.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    categories_styles: {
      name: "categories_styles",
      src: "https://turbo-categories-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    onboarding_styles: {
      name: "onboarding_styles",
      src: "https://turbo-onboarding-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    self_onboarding_styles: {
      name: "self_onboarding_styles",
      src: "https://turbo-self-onboarding-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },

    picker_schedule_styles: {
      name: "picker_schedule_styles",
      src: "https://turbo-picker-schedule-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
    supplier_management: {
      name: "supplier_management",
      src: "https://turbo-supplier-manage-mf.dev.rappi.com/static/js/bundle.min.css",
      type: "text/css",
    },
    product_visibility_styles: {
      name: "product_visibility_styles",
      src: "https://turbo-product-visibility-mf.dev.rappi.com/static/css/bundle.min.css",
      type: "text/css",
    },
  },
  prod: {
    fake_orders_styles: {
      name: "fake_orders_styles",
      src: getStylesPath("tmf-fake-orders", code),
      type: "text/css",
    },
    users_styles: {
      name: "users_styles",
      src: getStylesPath("tmf-users", code),
      type: "text/css",
    },
    order_tracking_styles: {
      name: "order_tracking_styles",
      src: getStylesPath("tmf-order-tracking"),
      type: "text/css",
    },
    realtime_fo_styles: {
      name: "realtime_fo_styles",
      src: getStylesPath("tmf-realtime-fo"),
      type: "text/css",
    },
    accuracy_tracker_styles: {
      name: "accuracy_tracker_styles",
      src: getStylesPath("tmf-accuracy-tracker"),
      type: "text/css",
    },
    cargo_invoice_styles: {
      name: "cargo_invoice_styles",
      src: getStylesPath("turbo-utils-mf", code),
      type: "text/css",
    },
    turbo_bulk_upload_styles: {
      name: "bulk_upload_styles",
      src: getStylesPath("turbo-bulk-upload-mf", code),
      type: "text/css",
    },
    turbo_charm_price_styles: {
      name: "charm_price_styles",
      src: getStylesPath("turbo-charm-price-mf", code),
      type: "text/css",
    },
    turbo_sell_pricing_styles: {
      name: "sell_pricing_styles",
      src: getStylesPath("turbo-sell-pricing-mf", code),
      type: "text/css",
    },
    turbo_promotion_styles: {
      name: "turbo_promotion_styles",
      src: getStylesPath("turbo-promotions-mf", code),
      type: "text/css",
    },
    turbo_competitive_styles: {
      name: "competitive_styles",
      src: getStylesPath("turbo-competitive-mf", code),
      type: "text/css",
    },
    turbo_wishlist_styles: {
      name: "wishlist_styles",
      src: getStylesPath("turbo-wishlist-mf", code),
      type: "text/css",
    },
    purchase_orders: {
      name: "purchase_orders_styles",
      src: getStylesPath("turbo-purchase-orders-mf", code),
      type: "text/css",
    },
    consignment_orders: {
      name: "consignment_orders_styles",
      src: getStylesPath("turbo-consignment-mf", code),
      type: "text/css",
    },
    po_calendar_styles: {
      name: "po_calendar_styles",
      src: getStylesPath("turbo-po-calendar-mf", code),
      type: "text/css",
    },
    pos_styles: {
      name: "pos_styles",
      src: getStylesPath("turbo-pos-mf", code),
      type: "text/css",
    },
    financial_managment: {
      name: "financial_managment_styles",
      src: getStylesPath("turbo-purchase-orders-mf", code),
      type: "text/css",
    },
    replenishment_styles: {
      name: "replenishment_styles",
      src: getStylesPath("turbo-replenishment-mf", code),
      type: "text/css",
    },
    permissions_styles: {
      name: "permissions_styles",
      src: getStylesPath("turbo-permissions-mf", code),
      type: "text/css",
    },
    audit_report_styles: {
      name: "audit_report_styles",
      src: getStylesPath("turbo-audit-report-mf", code),
      type: "text/css",
    },
    roles_styles: {
      name: "roles_styles",
      src: getStylesPath("turbo-roles-mf", code),
      type: "text/css",
    },
    sc_approval_styles: {
      name: "sc_approval_styles",
      src: getStylesPath("turbo-sc-approval-mf", code),
      type: "text/css",
    },
    transformations_styles: {
      name: "transformations_styles",
      src: getStylesPath("turbo-transformations-mf", code),
      type: "text/css",
    },
    inventory_savvy_styles: {
      name: "inventory_savvy_styles",
      src: getStylesPath("turbo-inventory-savvy-mf", code),
      type: "text/css",
    },
    supply_purchase_orders_styles: {
      name: "supply_purchase_orders_styles",
      src: getStylesPath("turbo-pt-order-mf", code),
      type: "text/css",
    },
    supply_transfer_orders_styles: {
      name: "supply_transfer_orders_styles",
      src: getStylesPath("turbo-pt-order-mf", code),
      type: "text/css",
    },
    supply_consignment_orders_styles: {
      name: "supply_consignment_orders_styles",
      src: getStylesPath("turbo-pt-order-mf", code),
      type: "text/css",
    },
    audit_inventory_styles: {
      name: "audit_inventory_styles",
      src: getStylesPath("turbo-audit-inventory-mf", code),
      type: "text/css",
    },
    campaign_styles: {
      name: "campaign_styles",
      src: getStylesPath("turbo-campaign-mf", code),
      type: "text/css",
    },
    multibrand_styles: {
      name: "multibrand_styles",
      src: getStylesPath("turbo-multibrand-mf", code),
      type: "text/css",
    },
    assignments_styles: {
      name: "assignments_styles",
      src: getStylesPath("turbo-assignments-mf", code),
      type: "text/css",
    },
    cold_products_styles: {
      name: "cold_products_styles",
      src: getStylesPath("turbo-cold-products", code),
      type: "text/css",
    },
    cyclics: {
      name: "cyclics_styles",
      src: getStylesPath("turbo-cyclics-mf", code),
      type: "text/css",
    },
    catalog_styles: {
      name: "catalog_styles",
      src: getStylesPath("turbo-catalog-mf", code),
      type: "text/css",
    },
    kpis_styles: {
      name: "kpis_styles",
      src: getStylesPath("turbo-kpis-mf", code),
      type: "text/css",
    },
    price_list_styles: {
      name: "price_list_styles",
      src: getStylesPath("turbo-price-list-mf", code),
      type: "text/css",
    },
    catman_price_list_styles: {
      name: "catman_price_list_styles",
      src: getStylesPath("turbo-catman-price-list-mf", code),
      type: "text/css",
    },
    order_monitoring_styles: {
      name: "order_monitoring_styles",
      src: getStylesPath("turbo-order-monitoring", code),
      type: "text/css",
    },
    approval_request_styles: {
      name: "approval_request_styles",
      src: getStylesPath("turbo-approval-request", code),
      type: "text/css",
    },
    categories_styles: {
      name: "categories_styles",
      src: getStylesPath("turbo-categories-mf", code),
      type: "text/css",
    },
    onboarding_styles: {
      name: "onboarding_styles",
      src: getStylesPath("turbo-onboarding-mf", code),
      type: "text/css",
    },
    self_onboarding_styles: {
      name: "self_onboarding_styles",
      src: getStylesPath("turbo-self-onboarding-mf", code),
      type: "text/css",
    },
    picker_schedule_styles: {
      name: "picker_schedule_styles",
      src: getStylesPath("turbo-picker-schedule-mf", code),
      type: "text/css",
    },
    supplier_management: {
      name: "supplier_management",
      src: getStylesPath("turbo-supplier-manage-mf", code),
      type: "text/css",
    },
    product_visibility_styles: {
      name: "product_visibility_styles",
      src: getStylesPath("turbo-product-visibility-mf", code),
      type: "text/css",
    },
  },
  local: {
    fake_orders_styles: {
      name: "fake_orders_styles",
      src: "http://localhost:5000/static/css/bundle.min.css",
      type: "text/css",
    },
    users_styles: {
      name: "users_styles",
      src: "http://localhost:5100/static/css/bundle.min.css",
      type: "text/css",
    },
    order_tracking_styles: {
      name: "order_tracking_styles",
      src: "http://localhost:5200/static/css/bundle.min.css",
      type: "text/css",
    },
    realtime_fo_styles: {
      name: "realtime_fo_styles",
      src: "http://localhost:5300/static/css/bundle.min.css",
      type: "text/css",
    },
    accuracy_tracker_styles: {
      name: "accuracy_tracker_styles",
      src: "http://localhost:5600/static/css/bundle.min.css",
      type: "text/css",
    },
    cargo_invoice_styles: {
      name: "cargo_invoice_styles",
      src: "http://localhost:5700/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_bulk_upload_styles: {
      name: "bulk_upload_styles",
      src: "http://localhost:5900/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_charm_price_styles: {
      name: "charm_price_styles",
      src: "http://localhost:5900/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_sell_pricing_styles: {
      name: "sell_pricing_styles",
      src: "http://localhost:3000/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_promotion_styles: {
      name: "turbo_promotion_styles",
      src: "http://localhost:5000/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_competitive_styles: {
      name: "competitive_styles",
      src: "http://localhost:5000/static/css/bundle.min.css",
      type: "text/css",
    },
    turbo_wishlist_styles: {
      name: "wishlist_styles",
      src: "http://localhost:5800/static/css/bundle.min.css",
      type: "text/css",
    },
    purchase_orders: {
      name: "purchase_orders_styles",
      src: "http://localhost:5001/static/css/bundle.min.css",
      type: "text/css",
    },
    consignment_orders: {
      name: "consignment_orders_styles",
      src: "http://localhost:5090/static/css/bundle.min.css",
      type: "text/css",
    },
    po_calendar_styles: {
      name: "po_calendar_styles",
      src: "http://localhost:5003/static/css/bundle.min.css",
      type: "text/css",
    },
    pos_styles: {
      name: "pos_styles",
      src: "http://localhost:5007/static/css/bundle.min.css",
      type: "text/css",
    },
    financial_managment: {
      name: "financial_managment_styles",
      src: "http://localhost:5005/static/css/bundle.min.css",
      type: "text/css",
    },
    roles_styles: {
      name: "roles_styles",
      src: "http://localhost:5006/static/css/bundle.min.css",
      type: "text/css",
    },
    replenishment_styles: {
      name: "replenishment_styles",
      src: "http://localhost:5001/static/css/bundle.min.css",
      type: "text/css",
    },
    sc_approval_styles: {
      name: "sc_approval_styles",
      src: "http://localhost:5008/static/css/bundle.min.css",
      type: "text/css",
    },
    transformations_styles: {
      name: "transformations_styles",
      src: "http://localhost:5009/static/css/bundle.min.css",
      type: "text/css",
    },
    inventory_savvy_styles: {
      name: "inventory_savvy_styles",
      src: "http://localhost:5009/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_purchase_orders_styles: {
      name: "supply_purchase_orders_styles",
      src: "http://localhost:5009/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_transfer_orders_styles: {
      name: "supply_transfer_orders_styles",
      src: "http://localhost:5009/static/css/bundle.min.css",
      type: "text/css",
    },
    supply_consignment_orders_styles: {
      name: "supply_consignment_orders_styles",
      src: "http://localhost:5009/static/css/bundle.min.css",
      type: "text/css",
    },
    audit_inventory_styles: {
      name: "audit_inventory_styles",
      src: "http://localhost:5011/static/css/bundle.min.css",
      type: "text/css",
    },
    campaign_styles: {
      name: "campaign_styles",
      src: "http://localhost:5011/static/css/bundle.min.css",
      type: "text/css",
    },
    multibrand_styles: {
      name: "multibrand_styles",
      src: "http://localhost:5011/static/css/bundle.min.css",
      type: "text/css",
    },
    permissions_styles: {
      name: "permissions_styles",
      src: "http://localhost:5012/static/css/bundle.min.css",
      type: "text/css",
    },
    audit_report_styles: {
      name: "audit_report_styles",
      src: "http://localhost:5013/static/css/bundle.min.css",
      type: "text/css",
    },
    assignments_styles: {
      name: "assignments_styles",
      src: "http://localhost:5015/static/css/bundle.min.css",
      type: "text/css",
    },
    cold_products_styles: {
      name: "cold_products_styles",
      src: "http://localhost:5014/static/css/bundle.min.css",
      type: "text/css",
    },
    cyclics_styles: {
      name: "cyclics_styles",
      src: "http://localhost:5016/static/css/bundle.min.css",
      type: "text/css",
    },
    catalog_styles: {
      name: "catalog_styles",
      src: "http://localhost:5018/static/css/bundle.min.css",
      type: "text/css",
    },
    warehouse_config_styles: {
      name: "warehouse_config_styles",
      src: "http://localhost:5018/static/css/bundle.min.css",
      type: "text/css",
    },
    kpis_styles: {
      name: "kpis_styles",
      src: "http://localhost:5019/static/css/bundle.min.css",
      type: "text/css",
    },
    price_list_styles: {
      name: "price_list_styles",
      src: "http://localhost:5021/static/css/bundle.min.css",
      type: "text/css",
    },
    catman_price_list_styles: {
      name: "catman_price_list_styles",
      src: "http://localhost:5022/static/css/bundle.min.css",
      type: "text/css",
    },
    order_monitoring_styles: {
      name: "order_monitoring_styles",
      src: "http://localhost:5023/static/css/bundle.min.css",
      type: "text/css",
    },
    approval_request_styles: {
      name: "approval_request_styles",
      src: "http://localhost:5025/static/css/bundle.min.css",
      type: "text/css",
    },
    categories_styles: {
      name: "categories_styles",
      src: "http://localhost:5026/static/css/bundle.min.css",
      type: "text/css",
    },
    onboarding_styles: {
      name: "onboarding_styles",
      src: "http://localhost:5028/static/css/bundle.min.css",
      type: "text/css",
    },
    self_onboarding_styles: {
      name: "self_onboarding_styles",
      src: "http://localhost:5029/static/css/bundle.min.css",
      type: "text/css",
    },
    picker_schedule_styles: {
      name: "picker_schedule_styles",
      src: "http://localhost:5031/static/css/bundle.min.css",
      type: "text/css",
    },
    supplier_management: {
      name: "supplier_management_styles",
      src: "http://localhost:5034/static/css/bundle.min.css",
      type: "text/css",
    },
    product_visibility_styles: {
      name: "product_visibility_styles",
      src: "http://localhost:3000/static/css/bundle.min.css",
      type: "text/css",
    },
  },
};
